module.exports = __webpack_public_path__ + "static/media/2.33cffacd.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/perks/2.png
// module id = 58
// module chunks = 0